export default "__VITE_ASSET__CPuDEtmY__"